import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BedroomBabyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"bedroom_baby"}/>
}
